module.exports = __webpack_public_path__ + "../../../static/img/c_im_17.b52cd5de.png";